import * as yup from 'yup';

import { baseSchema } from '@/features/Input/inputBaseSchema';
import { genericStoreFactory } from '@/utils/genericStoreFactory/genericStoreFactory';

const pfeSchema = yup.object({
  deckungssumme: yup.string().required().default(''),
  demvRabattiert: yup.bool().default(true),
  laufzeit: yup.string().required().default(''),
  selbstbeteiligung: yup.string().required().default(''),
  tarifgruppe: yup.string().required().default(''),
  vorschaden: yup.string().required().default(''),

  pferdeAnzahl: yup.number().min(1).max(5).required().default(1),
  reitverein: yup.bool().default(false),
});

export const inputSchema = pfeSchema.concat(baseSchema);

export type InputStore = yup.Asserts<typeof inputSchema>;

const defaultState = inputSchema.getDefault() as InputStore;

export const usePfeInputStore = genericStoreFactory(
  defaultState,
  'PfeInputStore',
);
